import Q from 'q';

import { UserPreferenceKeys } from 'bundles/in-course-stores/constants/UserPreferences';
import { getUserPreference, setUserPreference } from 'bundles/in-course-stores/utils/honorsUserPreferenceUtils';

/**
 * @param {Fluxible.ActionContext} actionContext
 * @return {Promise}
 */
export const loadHonorsUserPreferences = function (actionContext: $TSFixMe, { authenticated }: $TSFixMe) {
  if (actionContext.getStore('HonorsUserPreferencesStore').hasLoaded()) {
    return Q();
  }

  if (authenticated) {
    return getUserPreference(UserPreferenceKeys.HONORS)
      .then((honorsUserPreferences) => {
        actionContext.dispatch('LOAD_HONORS_USER_PREFERENCES', honorsUserPreferences);
      })
      .fail((error) => {
        actionContext.dispatch('LOAD_HONORS_USER_PREFERENCES', {});
      });
  } else {
    actionContext.dispatch('LOAD_HONORS_USER_PREFERENCES', {});
    return Q();
  }
};

/**
 * @param {Fluxible.ActionContext} actionContext
 * @param {object} options
 * @return {Promise}
 */
export const setHonorsUserPreferences = function (
  actionContext: $TSFixMe,
  { authenticated, updatedHonorsUserPreferences }: $TSFixMe
) {
  if (authenticated) {
    return setUserPreference(UserPreferenceKeys.HONORS, updatedHonorsUserPreferences).then(() => {
      actionContext.dispatch('LOAD_HONORS_USER_PREFERENCES', updatedHonorsUserPreferences);
    });
  } else {
    actionContext.dispatch('LOAD_HONORS_USER_PREFERENCES', updatedHonorsUserPreferences);

    return Q();
  }
};

export const setLessonSkipped = function (actionContext: $TSFixMe, { lessonId, skipped }: $TSFixMe) {
  actionContext.dispatch('SET_LESSON_SKIPPED', { lessonId, skipped });
};
